<template>
    <header class="bg-white">
        <div class="px-4">
            <div class="flex items-center justify-between py-4 gap-4 flex-wrap">
                <div class="flex items-center gap-x-2">
                    <img src="../assets/images/short-logo.svg" alt="Davr Bank logo" />
                    <span
                        class="font-semibold text-[#313131] text-xl uppercase hidden md:inline-block"
                    >
                        Davr-Business
                    </span>
                </div>

                <div class="flex items-center gap-x-4">
                    <bank-open-days-component />
                    <el-select
                        style="width: 240px"
                        v-model="selectedLocale"
                        @change="handleLangChange"
                        class="lang-select"
                    >
                        <el-option
                            v-for="item in languages"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                        />
                    </el-select>

                    <button
                        class="flex items-center gap-x-2 px-3 py-2 bg-slate-50 cursor-pointer rounded"
                        @click="onClickLogOutBtn"
                    >
                        <span>{{ adminName }}</span>
                        <IconUsers01 cls="text-xl text-[#0D6992]" />
                    </button>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";
import router from "@/router";
import { languages, selectedLocale } from "@/i18n/i18n";
import { ElMessage, ElMessageBox } from "element-plus";
import IconUsers01 from "./icons/users/IconUsers01.vue";
import BankOpenDaysComponent from "@/components/bank-open-days/BankOpenDaysComponent.vue";

const { t } = useI18n();

const adminName = computed(() => store.state.user.name);

const handleLangChange = () => {
    window.location.replace(window.location.href);
};

const onClickLogOutBtn = () => {
    ElMessageBox.confirm(t("notifications.do_you_want_to_log_out"), t("notifications.caution"), {
        confirmButtonText: t("buttons.yes"),
        cancelButtonText: t("buttons.no"),
        type: "warning",
    })
        .then(() => {
            store.commit("signOut");
            router.push("/auth");
        })
        .catch(() => {
            ElMessage({
                showClose: true,
                message: t("notifications.thanks_for_staying_tuned"),
            });
        });
};
</script>

<style scoped>
.lang-select:deep(.el-input__wrapper) {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: rgba(242, 243, 245, 0.5);
    border-radius: 8px;
    height: 70%;
    padding: 5px 10px 5px 10px;
    cursor: pointer;
}
</style>
